import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const EggDonor = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Egg Donor IVF in Ambala | Donor Egg Program | Amaanat IVF</title>

        <meta
          name="description"
          content="Egg donor IVF program in Ambala at Amaanat IVF. High success rates with screened donors and advanced fertility treatments."
        />

        <link rel="canonical" href="https://amaanativf.com/services/donor" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "Egg Donor IVF Program",
            "description": "IVF using donor eggs for women with low ovarian reserve",
            "procedureType": "Therapeutic",
            "bodyLocation": "Uterus",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is an egg donor IVF program?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Egg donor IVF uses eggs from a healthy donor to help women achieve pregnancy when their own eggs are not viable."
                }
              },
              {
                "@type": "Question",
                "name": "Who needs egg donor IVF?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Women with low ovarian reserve, poor egg quality, or repeated IVF failures may benefit from donor egg IVF."
                }
              },
              {
                "@type": "Question",
                "name": "Is egg donor IVF safe?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, it is a safe and ethical procedure with carefully screened donors and medical supervision."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>Egg Donor IVF Program in Ambala</h1>

          <p>
            Helping couples achieve pregnancy with advanced donor egg IVF solutions
          </p>

          <div className="hero-stats">
            <span>95%+</span> Success Rate
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section>
            <h2>About Egg Donor IVF Program</h2>
            <p>
              Our egg donor program helps women with low ovarian reserve achieve
              successful pregnancy using donor eggs with high success rates.
            </p>
          </section>

          <section>
            <h2>Benefits of Donor Egg IVF</h2>
            <ul>
              <li>High success rates compared to traditional IVF</li>
              <li>Carefully screened and healthy egg donors</li>
              <li>Safe, ethical, and confidential process</li>
            </ul>
          </section>

          {/* ✅ Hidden SEO Content (NO UI IMPACT) */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best Egg Donor IVF Centre in Ambala</h2>
            <p>
              Amaanat IVF offers one of the most trusted egg donor IVF programs in Ambala.
              With advanced fertility techniques, experienced embryologists, and strict donor screening,
              we ensure high success rates and personalized care for every patient.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default EggDonor;